var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIlustracija(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 325",
    style: {
      enableBackground: "new 0 0 600 325"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#AA6276;}\n\t.st2{fill:#FA7268;}\n\t.st3{fill:#231F20;}\n\t.st4{fill:#159497;}\n\t.st5{fill:#6E5DD8;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "600x325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.3,288.9c-30.5,0-67.7-5.7-111.6-22.2c-3-1-5.8-2.3-8.5-3.5s-5.5-2.5-8.4-3.5 c-25.8-12.3-46.8-25.4-64.3-40.1l1-1.2c17.4,14.6,38.4,27.6,63.9,39.8c3,1,5.8,2.3,8.5,3.5s5.5,2.5,8.4,3.5 c81.9,30.8,140.4,23.9,175,12.6c20.9-6.8,37.3-18.9,46.2-34.1c18.2-30.7,2.7-63.5-16-82.2c-8.4-7.5-17.7-13.8-27.8-18.9 c-13.7-6.8-28.1-12.1-42.9-15.9c-53.2-13.5-108.8-16.3-165.4-8.1l-0.2-1.5c56.8-8.2,112.7-5.4,166,8.1c14.9,3.8,29.4,9.2,43.1,16.1 c10.2,5.1,19.7,11.5,28.2,19.1c19.1,19.1,34.9,52.6,16.3,84.1c-9.1,15.5-25.8,27.8-47,34.7C479.5,284.6,458,288.9,431.3,288.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 488.8,
    y: 226,
    className: "st1",
    width: 11,
    height: 11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "255.4,42.9 264.4,27.4 246.5,27.4  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263,110.3c4.8-14.6,10.5-30.5,23.6-38.5c12-7.3,28.1-6,40.1,1.4s20,20.1,24.2,33.5s4.6,27.8,4,41.8 c-0.2,4.7-0.5,9.6-2.6,13.9c-2.9,5.9-8.6,9.8-14.4,12.8c-15.2,7.9-32.8,11.5-49.7,8.8c-7.9-1.3-15.5-3.9-22.4-7.8 c-5.5-3.1-15.6-9.1-17.9-15.5c-2-5.8,4.1-16.3,5.9-21.8L263,110.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.4,287c33,13.9,71.5,15.5,105.3,3.9c-0.5-45.3,3.7-91.4,10.5-136.1c-11-6.8-24.6-5.4-37-2.8 s-25.2,6.1-37.5,3c-8.6-2.2-16.3-7.6-24.9-9.7c-15.2-3.7-32.3,4.3-40.2,18.9c6.1,6.1,8.8,13.9,11.4,22.5 C242.5,218.5,247.4,253.7,245.4,287z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 306,
    cy: 105.1,
    r: 37.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255,307.8c6.4-29.4,9.7-59.4,9.6-89.5c0-12.7-0.8-26-7.2-37c-7.1-12.3-20.6-20.1-34.5-22.9s-28.4-1.1-42.3,2 c-9.5,2.1-20.6,0.2-28.2-5.8c-7.4-5.8-11.4-14.8-14.6-23.6c-10-27.7-1.4-53.3,1.3-85.6c-7.1-0.7-16.2-1.8-23.3-2.5 c-5.3,38-16.8,76.8-3.5,112.8c8.8,23.7,21.3,45.8,31,69.1s16.5,48.7,13,73.7C185.4,316.2,222.6,318.5,255,307.8z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.5,174c1.1,1.7,2.2,3.5,2.1,5.5c-0.2,2.5-2.4,4.3-4.8,4.1c-1.7-0.1-3.1-1.2-3.8-2.8 c1.8,4.2,3.5,8.6,3.8,13.2s-1.1,9.6-4.7,12.4c-5.1,4-12.9,2.4-17.9-1.8s-7.6-10.4-10.2-16.4c-2.2-5.2-4.5-11-2.9-16.5 c1.5-5,6.1-8.7,11-10.4c4.4-1.5,11.7-3.1,16.3-1.3C187.5,162.1,190.6,169.7,193.5,174z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187,159.6c3.5-0.4,6-3.6,5.6-7.1c0-0.1,0-0.2,0-0.2c-1.6-10.4-11.4-17.6-21.9-16c-0.3,0-0.5,0.1-0.8,0.1 c-8.5,1.7-15,9-18,17.1c-1.9,5.5-3,11.3-3.1,17.2c-0.1,1.8,1.3,3.4,3.1,3.4c0.8,0,1.7-0.3,2.3-0.8C163.2,165.7,175,161.1,187,159.6 z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 214.8,
    cy: 111.2,
    r: 37.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.2,111.6c8.9-8.8,15-19.6,19.5-31c-16.9-11.6-40-7.2-51.5,9.7c-8.8,12.8-8.6,29.7,0.3,42.3 C196.3,127.7,207.1,120.6,216.2,111.6z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.9,82.7c-4.7,1.5-8,5.7-10.3,10.1s-3.8,9.2-6.5,13.3c-8.4,13-25.8,16.7-38.7,8.2c-8-5.2-12.8-14-12.7-23.5 c0.1-9,4.6-17.6,11.1-23.8s15-10.1,23.6-12.5c8.5-2.3,17.5-3.3,26-1c7.9,2.1,14.9,7,20.6,12.8s10.5,12.5,15.2,19.2 c1.1,1.6-4,4-4.9,4.2c-2.9,0.4-4.3-1.2-6.6-2.7C176.9,83.7,170.8,80.8,164.9,82.7z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.3,85.7c2-3.5,7-5,10.5-2.8c10,6.4,18.5,14.7,30,18.5c6.5,2.2,13.4,3.2,20.3,3.1 c-0.5-20.5-17.4-36.7-37.9-36.2c-20.1,0.4-36.1,16.8-36.3,36.8c0,1.9-6.8,19,1.9,20.8C273.2,103.3,277.5,93.9,282.3,85.7z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 206.7,
    cy: 118.9,
    r: 5.5
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510.6,73.9c-0.5-4.7,1.3-9.3,3.3-13.6c2-4.3,4.2-8.7,4.3-13.4S515.6,37,511,36c-0.8-0.1-1.7-0.3-2.5-0.5 c-0.7-0.3-1.3-0.6-1.9-0.9c-3.4-1.8-7.4-2.2-11.1-1.2c-1.6,0.5-3.1,1.3-4.5,2.3c-1.8,1.5-3.2,3.5-3.8,5.8c-0.1,0.6-0.4,1.2-0.7,1.7 c-0.5,0.4-1.1,0.8-1.8,1c-2.5,1.3-3.4,4.4-3.3,7.2c0.4,8.4,7.7,15.6,6.9,24L510.6,73.9z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M412.2,295.2c18.1-20.8,29.7-48.1,32.9-75.4c52-28.7,79-88.3,66.2-146.4l-23.5,1.3c2.8,22.2-0.9,45.8-13.8,64 s-36.1,29.8-58,25.4c-9.5-1.9-18.2-6.6-27.4-9.9s-19.4-5.3-28.5-1.7c-22.9,9-24.9,43.9-24.6,68.4s7.4,48.5,14.5,72 C371.2,299.7,390.5,300.5,412.2,295.2z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M483.7,122.2c-9-12.2-25.7-10.9-38.3-16.7c-10.8-4.9-16.1-15-25.4-21.5c-6.9-4.9-14.3-8.7-23-8.7 c-0.8,0-1.5-0.1-2.3-0.3c-5.7,0.1-11.4,1.1-16.7,3.2c-5.8,2.4-10,7.5-11.3,13.6c-0.1,0.3-0.1,0.7-0.2,1 c8.9,8.7,36.4,35.9,42.4,46.1c7.2,12.3,2.7,19.4,10.2,31.7s20.8,20.8,36.5,18.8c18.7-2.4,34.4-16.4,35.9-35.6 C492.4,143,490.2,131,483.7,122.2z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 394.3,
    cy: 111.2,
    r: 37.1
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.5,98.7c-6.6,0.1-13.1-1.1-19.3-3.3c-3.4-1.3-6.5-3.1-9.5-5.2c-11.6,16.8-7.4,39.9,9.4,51.6 c16,11.1,37.8,7.9,50-7.3C407.6,127.1,394.3,116.2,392.5,98.7z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 403,
    cy: 116.3,
    r: 5.5
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.5,24.7c2.4-3.2,2.1-7.6-0.6-10.5c-2.4-2.4-5.9-3-9.2-3.4c-4.6-0.5-9.7-0.6-13.5,2.2s-5.2,7.8-4.9,12.4 s1.6,13.2,3.4,17.5l23.3,2.5c0,0,5-14.4,3.4-18.4S140.5,24.7,140.5,24.7z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M134.3,30.9c-0.1,0-0.2,0-0.2,0c-1.9-0.6-4.1-1.4-5.6-3.1c-0.9-1-1.3-2.5-1.1-3.9c0.1-1.1,0.6-2,1.4-2.5 c1.8-1.3,4.1-0.6,6,0.1c0.8,0.3,2.5,0.9,4.2,1.5c1.5,0.5,3,1.1,3.8,1.4c0.4,0.1,0.6,0.6,0.4,1c-0.2,0.4-0.6,0.6-1,0.4 c-0.8-0.3-2.2-0.8-3.7-1.4c-1.7-0.6-3.4-1.2-4.2-1.5c-1.4-0.5-3.4-1.2-4.6-0.3c-0.4,0.3-0.7,0.8-0.8,1.5c-0.1,1,0.2,2.1,0.8,2.8 c1.2,1.4,3.2,2,4.9,2.6c0.4,0.1,0.6,0.6,0.5,0.9C134.9,30.7,134.6,30.9,134.3,30.9z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M128.1,25.8C128,25.8,128,25.8,128.1,25.8l-4-0.1c-1.3,0-2.5-0.1-3.8-0.5c-1.4-0.4-2.5-1.4-3.1-2.8 c-0.2-0.4,0-0.8,0.4-1s0.8,0,1,0.4c0.4,0.9,1.2,1.6,2.1,1.9c1.1,0.3,2.2,0.4,3.4,0.4l4,0.1c0.4,0,0.7,0.4,0.7,0.8 C128.8,25.5,128.5,25.8,128.1,25.8z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M490.9,53.2v-1.5l3.9-0.1c2.8,0,5.3-0.2,7.1-1.6c1-0.8,1.7-2.3,1.1-3.2c-0.5-0.8-1.7-0.9-3-1.1 c-2.6-0.3-5.2-0.8-7.7-1.6c-1.7-0.5-5.4-0.9-7.3-0.3l-0.4-1.4c2.3-0.7,6.2-0.3,8.2,0.3c2.4,0.7,4.9,1.3,7.4,1.5 c1.3,0.1,3.2,0.3,4.1,1.7c1.1,1.7,0.1,4-1.4,5.2c-2.4,1.8-5.6,1.8-8,1.9L490.9,53.2z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M507.6,51.2c-1.4,0-2.7-0.4-3.9-1.1l0.8-1.3c1.6,1,3.6,1.1,5.4,0.4c1.6-0.7,2.7-2.4,2.5-4.2l1.5-0.1 c0.2,2.5-1.2,4.8-3.4,5.8C509.5,51,508.5,51.2,507.6,51.2z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 367.1,
    cy: 170.4,
    r: 3.5
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 362.1,
    cy: 193.7,
    r: 3.5
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 360.2,
    cy: 217.1,
    r: 3.5
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 360.2,
    cy: 240.4,
    r: 3.5
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 362.1,
    cy: 261.9,
    r: 3.5
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 363.7,
    cy: 283.3,
    r: 3.5
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 236,
    cy: 108.4,
    r: 2.7
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 298,
    cy: 108.6,
    r: 2.7
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 318.8,
    cy: 108.6,
    r: 2.7
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 368.3,
    cy: 114,
    r: 2.7
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 251.4,
    cy: 114,
    r: 4
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 361.2,
    cy: 128.3,
    r: 4
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243,130.4c-4.5,0-8.2-3.7-8.2-8.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8c0,3.7,3,6.7,6.7,6.7 c0.4,0,0.8,0.3,0.8,0.8S243.5,130.4,243,130.4z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.9,126.2c-2.1,0-4.2-0.8-5.8-2.4c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0c2.6,2.6,6.9,2.6,9.5,0 c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1C313.1,125.4,311,126.2,308.9,126.2z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M372.7,135.1c-0.2,0-0.4,0-0.6,0c-0.4-0.1-0.7-0.4-0.7-0.8s0.4-0.7,0.8-0.6c1.8,0.2,3.5-1.1,3.7-2.9 c0.1-0.4,0.4-0.7,0.8-0.6c0.4,0.1,0.7,0.4,0.6,0.8C377.2,133.3,375.1,135.1,372.7,135.1z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.9,264.2c-15.3-7.1-26.3-14.4-34.6-22.9c-10.7-11-16.9-24.2-17.3-37.2c-0.5-14.9,7.1-29.1,19-35.4 c10.7-5.7,23.9-5.5,40.2,0.5c-12.7-8.6-23.1-20-30.5-33.6c-4.5-8.2-6.6-15.5-6.7-22.2c-0.1-8.6,3.7-16.5,9.8-20.6 c4.8-3.3,11.1-3.8,16.1-1.8c-5.1-7.2-6.7-16.4-4.1-25c3.6-10.8,13.3-18.5,24.6-19.6l0.1,1.5c-10.7,1-19.9,8.3-23.4,18.6 C61.4,75.8,63.9,86,70.5,93c0.8,0.6,1.6,1.3,2.2,2.1l-1.1,1c-0.8-0.7-1.5-1.3-2.2-2.1c-4.8-3.6-12.3-3.8-17.8,0 c-5.7,3.9-9.2,11.3-9.1,19.4c0.1,6.4,2.2,13.5,6.5,21.4c9,16.5,22.7,29.9,39.4,38.6l-0.7,1.3c-20.6-9.7-36.7-11.3-49-4.7 c-11.4,6-18.7,19.7-18.2,34c0.4,12.7,6.4,25.5,16.9,36.3c8.2,8.4,19.1,15.6,34.2,22.6L70.9,264.2z"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342.3,
    y: 18.1,
    className: "st2",
    width: 1.5,
    height: 29.6
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.3,
    y: 34.4,
    transform: "matrix(0.3663 -0.9305 0.9305 0.3663 212.9229 382.9136)",
    className: "st2",
    width: 36.6,
    height: 1.5
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.6,
    y: 44.1,
    transform: "matrix(0.7178 -0.6963 0.6963 0.7178 92.8938 318.8501)",
    className: "st2",
    width: 48.3,
    height: 1.5
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 71.2,
    cy: 263.5,
    r: 6.5
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.5,79c-7.1,20.8-7.1,43.4-0.3,64.2c-8.1-9.3-13.2-19.7-12.8-32S274.9,87.8,283.5,79z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIlustracija);
export default __webpack_public_path__ + "static/media/Footer-ilustracija.54cd128dfcd5b53fc601d603ee0a55ce.svg";
export { ForwardRef as ReactComponent };